// extracted by mini-css-extract-plugin
export default {"error":"globalStyle_error__nbtEf"};